/* global ve */
import {
  addToLog
} from './veb.js'
import cfg from './vecfg.js'
const vecfg = cfg.cfg
addToLog(`vecfg: ${JSON.stringify(vecfg)}`, false) // todo: remove after testing

const checkUserProviderName = async (debug = false) => {
  const userProfile = await ve.veapi.getCurrentUserUserProfile(debug) // get user profile
  addToLog(`checkUserProviderName:userProfile: ${JSON.stringify(userProfile)}`, debug)
  const providerName = await ve.amplify.getUserProviderName(debug)
  addToLog(`checkUserProviderName:providerName: ${providerName}`, debug)
  if (userProfile.providerName !== providerName) {
    const response = await ve.veapi.updateCurrentUserProviderName(providerName, debug)
    addToLog(`checkUserProviderName:response: ${JSON.stringify(response)}`, debug)
    return response
  } else {
    addToLog('checkUserProviderName:providerName already set in user profile', debug)
  }
}

const getDenyAccessTo = async (dbg = false) => {
  const fn = 'getDenyAccessTo'
  const defaultDenyAccessTo = ['Orchestration', 'Microgrid', 'Customers', 'CustomerService', 'Admin', 'Alerts', 'Events', 'Analytics', 'Financial Accounts', 'Assets', 'Contracts', 'Install']
  const denyAccessTo = []
  const hasAccessTo = await ve.veapi.getCurrentUserGroupsForType('satUiGroups', dbg)
  doLog(fn, { hasAccessTo }, dbg)
  for (const satUiGroup of defaultDenyAccessTo) {
    if (!hasAccessTo.includes(satUiGroup)) denyAccessTo.push(satUiGroup)
  }
  window.sessionStorage.setItem('denyAccessTo', denyAccessTo.join(','))
  const dat = window.sessionStorage.getItem('denyAccessTo')
  doLog(fn, { dat }, dbg)
}

export default {
  checkUserProviderName,
  getDenyAccessTo
}
